/* eslint-disable max-len */
export default (id = '', name = '', link = '', unbookCode = '') => ({
  text: `Dárek pro Týnu a Frantu byl úspěšně zamluven 🙂.\n
  Informace o dárku:\n
  Název: ${name}\n
  Odkaz do obchodu:${link}\n
  Pro zrušení zamluvení jdi na adresu: https://svatba.bachrony.com/darek/${id}/zruseni-zamluveni?unbookCode=${unbookCode}\n
  Moc děkujeme ❤️ a těšíme se 20.6., Týna a Franta`,
  html: `<!DOCTYPE html>
  <html lang="cs">
    <head>
      <meta charset="UTF-8">
      <title>Dárek pro Týnu a Frantu byl úspěšně zamluven</title>
    </head>
    <body>
      <h2 style="font-size: 18px;">Dárek pro Týnu a Frantu byl úspěšně zamluven 🙂.</h2>
      <br/>
      <p style="font-size: 18px;">Informace o dárku:</p>
      <p style="margin-left: 10px;"><b>Název:</b> ${name}</p>
      <p style="margin-left: 10px;"><b>Odkaz do obchodu:</b> <a href="${link}">${link}</a></p>
      <br/>
      <p style="font-size: 12px; font-style: italic;">Pro zrušení zamluvení jdi na adresu: <a href="https://svatba.bachrony.com/darek/${id}/zruseni-zamluveni?unbookCode=${unbookCode}">https://svatba.bachrony.com/darek/${id}/zruseni-zamluveni?unbookCode=${unbookCode}</a></p>
      <br/>    
      <p>Moc děkujeme ❤️ a těšíme se 20.6.,<br>Týna a Franta</p>
    </body>
  </html>`,
});
